<template>
    <div class="w-screen h-screen bg-gradient-to-b from-purple-100 to-purple-200 fixed top-0 left-o -z-10"></div>
    <div class="container mx-auto px-12">
        <Link href="/">
            <app-logo class="w-screen lg:max-w-lg mx-auto mt-40 lg:mt-60" theme="light"></app-logo>
        </Link>
        <div class="mx-auto sm:max-w-md my-6 px-6 py-4 bg-white shadow-md overflow-hidden rounded-lg">
            <slot />
        </div>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import AppLogo from "@/Components/AppLogo";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLogo,
        BreezeApplicationLogo,
        Link,
    }
}
</script>
